import { render, staticRenderFns } from "./orders.vue?vue&type=template&id=cc5716ee&scoped=true&"
import script from "./orders.vue?vue&type=script&lang=js&"
export * from "./orders.vue?vue&type=script&lang=js&"
import style0 from "./orders.vue?vue&type=style&index=0&id=cc5716ee&scoped=true&lang=css&"
import style1 from "./orders.vue?vue&type=style&index=1&id=cc5716ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc5716ee",
  null
  
)

export default component.exports